<template>
  <a-form-item
    :label="label"
    :required="required"
    :colon="colon"
    :label-col="{ sm: $slots.default ? (label ? labelColCount : 0) : 24 }"
    :wrapper-col="{ sm: label ? (24 - labelColCount - 1) : 24 }"
    :help="help"
  >
    <slot />
  </a-form-item>
</template>

<script>
export default {
  name: 'FormItemx',
  props: {
    label: {
      type: String,
      default: ''
    },
    required: {
      type: Boolean,
      default: false
    },
    labelColCount: {
      type: Number,
      default: 6
    },
    colon: {
      type: Boolean,
      default: false
    },
    help: {
      type: String,
      default: undefined
    }
  }
}
</script>

<style scoped>

</style>
